import { BoutonLien } from '../components/Boutons';
import { EtatVide } from '../components/EtatVide';

export function IntrouvablePage(): JSX.Element {
  return (
    <EtatVide
      titre="Page introuvable"
      description="Cette adresse ne correspond à aucun écran du back-office."
      action={
        <BoutonLien vers="/" variante="primaire">
          Retour au tableau de bord
        </BoutonLien>
      }
    />
  );
}
